import { ScreensInt } from '@tailwindConfig/screens.config';

document.addEventListener('DOMContentLoaded', () => {
  const tableSection = document.querySelector('.table-section');
  // AB TEST - Special Offer X Card
  if (window.location.pathname.match(/^\/(fr|it)\/payment-methods\/card-va\/?($|card-one-va\/?|card-plus-va\/?|x-card-va\/?)$/) ) {
    replaceCellXCard(tableSection)
  }
  if (document.querySelector('.three_or_more_cards')
    && document.querySelector('.table-section').querySelectorAll('.card-img').length > 3) {
    const tableSection = document.querySelector('.table-section');
    if (tableSection) {
      tableSection.querySelectorAll('.cells.swiper-wrapper').forEach(el => {
        el.classList.remove('md:grid');
      });
      mooveLastTooltip(tableSection);
      manageArrow(tableSection);
      scrollxTable(tableSection);
      if (window.matchMedia(`(min-width: ${ScreensInt.md}px)`).matches) {
        manageTooltipVisibility(tableSection);
      };
    };
  };
});

// AB TEST - Special Offer X Card 
const replaceCellXCard = (tableSection) => {
  const tableBody = tableSection.querySelector('.table-body');
  if (tableBody) {
    tableBody.querySelectorAll('.line-title').forEach((item) => {
      const itemContent = item.textContent.replace(/\r?\n|\r/g, '').trim();
      if (itemContent == 'Prix' || itemContent == 'Tariffa mensile per ogni carta non inclusa nel piano' || itemContent == 'Tariffe') {
        const row = item.parentNode.querySelectorAll('.cell');
        row.forEach((cell) => {
          const cellTitle = cell.querySelector('div:not(:empty)');
          const cellSubtitle = cell.querySelector('.sub-text');
          if (cellTitle) {
            const cellTitleText = cellTitle.textContent.replace(/\r?\n|\r/g, '').trim();
            if (cellTitleText == '20 € HT' || cellTitleText == '20€') {
              const pSubtitle = document.createElement('p');
              const pSubtitleIt = document.createElement('p');
              const pTitle = document.createElement('p');
              const strong = document.createElement('strong');
              pTitle.appendChild(strong);

              pTitle.style.color = '#9B81F6';
              pSubtitle.className = 'sub-text mx-20 md:mx-0 break-words caption font-light text-grey-600';
              strong.innerText = cellTitleText == '20 € HT' ? '2 mois offerts' : 'Gratis per 2 mesi';
              pSubtitle.innerText = 'puis 20 € HT/mois';

              pSubtitleIt.className = 'sub-text mx-20 md:mx-0 break-words caption font-light text-grey-600';
              pSubtitleIt.innerText = 'poi 20€/mese (IVA escl.)';

              cellTitle.replaceWith(pTitle);
              if (cellTitleText == '20 € HT') {
                cellSubtitle.replaceWith(pSubtitle)
              } else {
                pTitle.appendChild(pSubtitleIt)
              }
            }
          }
        });
      }
    });
  }
}

const mooveLastTooltip = (tableSection) => {
  const cardsImg = tableSection.querySelectorAll('.cells.swiper-wrapper .card-img');
  if (cardsImg) {
    const cardsImgCount = cardsImg.length;
    tableSection.querySelectorAll('.cells.swiper-wrapper .card-img').forEach((el, index) => {
      if (index == cardsImgCount - 1) {
        const closestDiv = el.closest('div');
        if (closestDiv && closestDiv.querySelector('.info-box')) {
          el.closest('div').querySelector('.info-box').style.left = "-245px";
        }
      }
    })
  }
}

const manageArrow = (tableSection) => {
  manageLeftArrowVisibility(tableSection);
  manageRightArrowScroll(tableSection);
  manageLeftArrowScroll(tableSection);
}

const scrollxTable = (tableSection) => {
  tableSection.querySelector('.sticky-header').addEventListener('scroll', () => {
    tableSection.querySelector('.overflow-section').scrollTo({left: tableSection.querySelector('.sticky-header').scrollLeft});
  });
  tableSection.querySelector('.overflow-section').addEventListener('scroll', () => {
    tableSection.querySelector('.sticky-header').scrollTo({left: tableSection.querySelector('.overflow-section').scrollLeft});
  });
}

const manageTooltipVisibility = (tableSection) => {
  document.addEventListener('scroll', () => {
    if (tableSection.querySelector('.sticky-header').classList.contains('reveal')) {
      tableSection.querySelectorAll('.tooltip-table').forEach((el) => {
        el.style.display = 'none';
      })
    } else if (!tableSection.querySelector('.sticky-header').classList.contains('reveal')) {
      tableSection.querySelectorAll('.tooltip-table').forEach((el) => {
        el.style.display = 'block';
      })
    }
  })
}

const manageLeftArrowVisibility = (tableSection) => {
  tableSection.querySelector('.overflow-section').addEventListener('scroll', () => {
    if (tableSection.querySelector('.overflow-section').scrollLeft > 0) {
      tableSection.querySelector('.md-left-arrow').style.visibility = 'visible';
    } else if (tableSection.querySelector('.overflow-section').scrollLeft == 0) {
      tableSection.querySelector('.md-left-arrow').style.visibility = 'hidden';
    }
  });
}

const manageRightArrowScroll = (tableSection) => {
  if (tableSection.querySelector('.md-right-arrow')) {
    tableSection.querySelector('.md-right-arrow').addEventListener('click', () => {
      const sectionWidth = tableSection.querySelector('.overflow-section').clientWidth;
      const over = tableSection.querySelector('.overflow-section').scrollWidth - sectionWidth;
      const el = tableSection.querySelector('.overflow-section');

      if (tableSection.querySelector('.overflow-section').scrollLeft == over) {
        el.scrollTo({left: 0});
      } else {
        el.scrollTo({left: 310 + el.scrollLeft});
      }
    })
  }
}

const manageLeftArrowScroll = (tableSection) => {
  if (tableSection.querySelector('.md-left-arrow')) {
    tableSection.querySelector('.md-left-arrow').addEventListener('click', () => {
      const el = tableSection.querySelector('.overflow-section');
      el.scrollTo({left: -310 + el.scrollLeft})
    })
  }
}
